



















import {Component, Vue} from 'vue-property-decorator';
import NavigationDrawerItems from '../components/NavigationDrawerItems.vue';
import IconButton from '@c/controls/IconButton.vue';

@Component({components: {NavigationDrawerItems, IconButton}})
export default class MainLayout extends Vue {
  drawer = true;
  mini = true;

  async created() {
    const mainMenuSettings = localStorage.getItem('mainMenuSettings');
    if (mainMenuSettings) this.mini = !JSON.parse(mainMenuSettings).showMainMenu;
  }

  openByButton() {
    this.drawer = true;
    this.mini = false;
  }

  get showAppBar() {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        return true;
      case 'sm':
        return true;
      case 'md':
        return true;
      case 'lg':
        return false;
      case 'xl':
        return false;
      default:
        return false;
    }
  }

  onMini(value: boolean) {
    this.mini = value;
  }
}
